import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
} from './integrationImport';

export const getZohoPeopleAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/zohoPeopleGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectZohoPeople = async (companyId, userId) => {
  const { data } = await httpClient.post('/zohoPeopleDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getZohoPeopleEmployees = async (companyId) => {
  const { data } = await httpClient.post('/zohoPeopleGetEmployees', {
    companyId,
  });
  return data;
};

export const autoMapZohoPeopleEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/zohoPeopleAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const saveZohoPeopleMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/zohoPeopleSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncZohoPeopleTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/zohoPeopleSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const exportAllZohoPeopleEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/zohoPeopleExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const previewZohoPeopleImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/zohoPeoplePreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const importZohoPeopleEmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/zohoPeopleImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToZohoPeopleImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'zohoPeople', onUpdate);

export const getZohoPeopleImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'zohoPeople', logId);

export const subscribeToZohoPeopleStatus = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc('zohoPeople')
    .onSnapshot(
      (doc) => {
        if (!doc.exists || !doc.data().connected) {
          onUpdate({
            connected: false,
            connectedAt: null,
            connectedBy: null,
            employeeMappings: {},
            employeeMappingsUpdatedAt: null,
            lastSyncAt: null,
            lastSyncStats: null,
          });
          return;
        }
        const d = doc.data();
        onUpdate({
          connected: true,
          connectedAt: d.connectedAt?.toDate?.() ?? null,
          connectedBy: d.connectedBy || null,
          employeeMappings: d.employeeMappings || {},
          employeeMappingsUpdatedAt:
            d.employeeMappingsUpdatedAt?.toDate?.() ?? null,
          lastSyncAt: d.lastSyncAt?.toDate?.() ?? null,
          lastSyncStats: d.lastSyncStats || null,
        });
      },
      (err) => {
        console.error('Zoho People status listener error:', err);
        onUpdate({
          connected: false,
          connectedAt: null,
          connectedBy: null,
          employeeMappings: {},
          employeeMappingsUpdatedAt: null,
          lastSyncAt: null,
          lastSyncStats: null,
        });
      }
    );
};
